import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import tw from 'twin.macro';
import Logo from '../logo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

const NAV_BAR_HEIGHT_PX = 68;

const NavBarContainer = styled.header`
  height: ${NAV_BAR_HEIGHT_PX}px;
  max-height: ${NAV_BAR_HEIGHT_PX}px;
  ${tw`
    shrink-0
    overflow-visible
    w-full
    box-border
    flex
    flex-row
    items-center
    px-4
    sm:px-6
    md:px-8
    lg:px-12
    xl:px-12
    2xl:px-[15%]
    justify-between
    mx-auto
    bg-gray-900
    shadow-md
    relative
    z-20
  `};
`;

const LogoContainer = styled.div`
  ${tw`flex items-center cursor-pointer`}
`;

const NavItemsContainer = styled.div<{ $isOpen: boolean }>`
  ${tw`
    flex
    md:flex-row
    flex-col
    md:items-center
    md:static
    absolute
    md:bg-transparent
    bg-gray-900
    md:w-auto
    w-full
    left-0
    md:shadow-none
    shadow-lg
    md:mt-0
    mt-[68px]
    transition-all
    duration-300
    ease-in-out
    md:py-0
    py-4
    md:opacity-100
    md:pointer-events-auto
  `}

  ${({ $isOpen }) =>
    $isOpen
      ? tw`opacity-100 pointer-events-auto top-0`
      : tw`opacity-0 pointer-events-none md:opacity-100 md:pointer-events-auto -top-4`}
`;

const NavItem = styled(Link)`
  ${tw`
    text-base
    font-medium
    md:mr-8
    md:my-0
    my-3
    px-4
    md:px-0
    text-gray-200
    transition-colors
    duration-200
    md:last:mr-0
    block
  `}
  &:hover {
    ${tw`text-red-400`}
  }
`;

const BurgerButton = styled.button`
  ${tw`
    md:hidden
    text-gray-900
    bg-gray-200
    transition-colors
    duration-200
  `}
  &:hover {
    ${tw`text-red-400`}
  }
`;

export const DealershipNavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <NavBarContainer>
      <LogoContainer onClick={handleLogoClick}>
        <Logo bgColor="dark" color="white" />
      </LogoContainer>

      <BurgerButton onClick={toggleMenu}>
        <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} size="xl" />
      </BurgerButton>

      <NavItemsContainer $isOpen={isMenuOpen}>
        <NavItem to="/" onClick={() => setIsMenuOpen(false)}>
          Home
        </NavItem>
        <NavItem to="/cars_on_sale" onClick={() => setIsMenuOpen(false)}>
          Inventory
        </NavItem>
        <NavItem to="/contact" onClick={() => setIsMenuOpen(false)}>
          Contact Us
        </NavItem>
      </NavItemsContainer>
    </NavBarContainer>
  );
};
